import React, { Component } from 'react';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import KioskScrollContainer from './KioskScrollContainer';
import KioskContentContainer from './KioskContentContainer';
import KioskSummaryContainer from './KioskSummaryContainer';
import HelpContainer from '../../../../listing/views/help/containers/HelpContainer';
import CancelConfirmContainer from '../../checkout/components/CancelConfirmContainer';
import TimeoutOverlay from '../../timeout-prompt/components/TimeoutOverlay';
import KioskSelectLanguageContainer from './KioskSelectLanguageContainer';
import KioskOverlay from '../../../../listing/components/KioskOverlay';

class KioskLayoutContainer extends Component {
    render() {
        if (this.props.cancelConfirm) {
            return <KioskOverlay><CancelConfirmContainer /></KioskOverlay>;
        }

        if (this.props.helpModal) {
            return <KioskOverlay><HelpContainer /></KioskOverlay>;
        }

        if (this.props.languageModal) {
            return <KioskOverlay><KioskSelectLanguageContainer /></KioskOverlay>;
        }

        if (this.props.showTimeoutPrompt) {
            return <KioskOverlay><TimeoutOverlay /></KioskOverlay>;
        }

    	if (this.props.splitPane) {
            return (
                <KioskOverlay
                    couponAlerts={this.props.couponAlerts}
                    inventoryErrors={this.props.inventoryErrors}
                    alertContainer={true}
                >
                    <KioskContentContainer>
                        <KioskScrollContainer>
                            {this.props.children}
                        </KioskScrollContainer>
                    </KioskContentContainer>
                    <KioskSummaryContainer />
                </KioskOverlay>
            );
        }

        return <KioskOverlay>{this.props.children}</KioskOverlay>;
    }
}

const mapStateToProps = (state, props) => {
    return {
        helpModal: state.ui.helpModal,
        cancelConfirm: state.ui.cancelConfirm,
        showTimeoutPrompt: state.timeout.showTimeoutPrompt,
        languageModal: state.ui.languageModal,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(KioskLayoutContainer);
